module.exports = __webpack_public_path__ + "img/01_-_Reduzido_Cor.25dc1225.png";